import React from "react";
import { convertDate } from "./Helper.js";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";

const LeftSide = ({
  activeButton,
  setActiveButton,
  customDays,
  setCustomDays,
  allTime,
  setAllTime,
  setSelectedStartDate,
  setSelectedEndDate,
}) => {
  const { getTextByKey, getDirection } = useContent();

  const handleClick = (type) => {
    let startDay = null;
    let endDay = null;
    let today = new Date();
    let firstDay = null;
    let lastDay = null;
    setActiveButton(activeButton !== type ? type : "");
    setAllTime((prev) => (type !== "alltime" ? false : !prev));
    setCustomDays((prev) => (type !== "custom" ? false : !prev));
    switch (type) {
      case "today":
        firstDay = new Date();
        lastDay = new Date();
        break;
      case "yesterday":
        let yesterday = new Date();
        yesterday.setDate(new Date().getDate() - 1);
        firstDay = yesterday;
        lastDay = yesterday;
        break;
      case "7days":
        let last7days = new Date();
        last7days.setDate(new Date().getDate() - 7);
        firstDay = last7days;
        lastDay = today;
        break;
      case "30days":
        let last30days = new Date();
        last30days.setDate(new Date().getDate() - 30);
        firstDay = last30days;
        lastDay = today;
        break;
      case "thismonth":
        firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case "prevmonth":
        firstDay = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case "alltime":
        break;
      case "custom":
        break;

      default:
        break;
    }
    if (type !== "custom" && type !== "alltime") {
      startDay = {
        date: convertDate(
          new Date(
            firstDay.getFullYear(),
            firstDay.getMonth(),
            firstDay.getDate()
          )
        ),
        dayOfMonth: firstDay.getDate(),
        isCurrentMonth: true,
      };
      endDay = {
        date: convertDate(
          new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
        ),
        dayOfMonth: lastDay.getDate(),
        isCurrentMonth: true,
      };
    }
    if (type === "alltime") {
      !allTime && setSelectedStartDate(null);
      !allTime && setSelectedEndDate(null);
    } else if (type === "custom") {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
    } else {
      setSelectedStartDate(activeButton !== type ? startDay : null);
      setSelectedEndDate(activeButton !== type ? endDay : null);
    }
  };

  return (
    <div className={`left-side ${getDirection() === "rtl" ? "rtl" : ""}`}>
      <span
        className={`${activeButton === "today" ? "active" : ""}`}
        onClick={() => {
          handleClick("today");
        }}
      >
        {getTextByKey("datepicker-today")}
      </span>
      <span
        className={`${activeButton === "yesterday" ? "active" : ""}`}
        onClick={() => {
          handleClick("yesterday");
        }}
      >
        {getTextByKey("datepicker-yesterday")}
      </span>
      <span
        className={`${activeButton === "7days" ? "active" : ""}`}
        onClick={() => {
          handleClick("7days");
        }}
      >
        {getTextByKey("datepicker-last-7-days")}
      </span>
      <span
        className={`${activeButton === "30days" ? "active" : ""}`}
        onClick={() => {
          handleClick("30days");
        }}
      >
        {getTextByKey("datepicker-last-30-days")}
      </span>
      <span
        className={`${activeButton === "thismonth" ? "active" : ""}`}
        onClick={() => {
          handleClick("thismonth");
        }}
      >
        {getTextByKey("datepicker-this-month")}
      </span>
      <span
        className={`${activeButton === "prevmonth" ? "active" : ""}`}
        onClick={() => {
          handleClick("prevmonth");
        }}
      >
        {getTextByKey("datepicker-prev-month")}
      </span>
      <span
        className={`${activeButton === "alltime" ? "active" : ""}`}
        onClick={() => {
          handleClick("alltime");
        }}
      >
        {getTextByKey("datepicker-all-time")}
      </span>
      <span
        className={`${activeButton === "custom" ? "active" : ""}`}
        onClick={() => {
          handleClick("custom");
        }}
      >
        {getTextByKey("datepicker-custom")}
      </span>
    </div>
  );
};

export default LeftSide;
